import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { useQuery as usePaymentModalDataQuery } from "@faire/web-api--source/endpoints/www/api/page-data/payment-modal-data/get-hooks";

export const usePaymentModalData = () => {
  const isLoggedIn = useIsLoggedInRetailer();
  const { data, isFetching } = usePaymentModalDataQuery({
    staleTime: Infinity,
    refetchOnMount: false,
    enabled: isLoggedIn,
  });

  return {
    data,
    isFetching,
  };
};
